import reset from 'styled-reset';
import {createGlobalStyle} from 'styled-components';

import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const GlobalStyles = createGlobalStyle`
  ${reset}

  @font-face {
    font-family: 'Tiempos Headline';
    src: url('/fonts/tiempos-headline-test-semibold.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  body {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    background: ${({theme}) => theme.body.bg};
  }

  input,
  button,
  textarea,
  select {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 32px;
    font-feature-settings: 'pnum' on, 'lnum' on;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;

export default GlobalStyles;
